/*
 * @Author: wangshengqiang
 * @Date: 2021-05-19 11:31:01
 * @LastEditTime: 2021-07-02 14:01:53
 * @LastEditors: wangshengqiang
 * @Description: 嵌入flow-h5使用的容器组件
 */
import React from 'react';
import cn from 'classnames';
import './index.less';
export default (props => {
  const {
    id,
    children,
    active,
    onClick,
    item
  } = props;
  const {
    component,
    style
  } = item;
  const cls = cn('c-module', component, {
    'c-module--active': active
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    "data-id": id,
    onClick: onClick
  }, children, /*#__PURE__*/React.createElement("i", {
    className: "c-module__frame"
  }), style && /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    dangerouslySetInnerHTML: {
      __html: style
    }
  }));
});